import { Footer } from './footer.jsx';
import { Navbar } from './header.jsx';
import { BelgiumMap, MiniMap, addCommuneBoundaryLayer, baseTileLayer, fetchCommunePolygon, fetchAddressLonLat } from './maps.jsx';
import { FramedPhoto, OrganicPhoto } from './media.jsx';
import {
  AsteriskHand,
  Brand,
  BrandMark,
  BrushBlob,
  BrushStroke,
  ChipGroup,
  DoodleArrow,
  DoodleCircle,
  DoodleDots,
  DoodleScribble,
  DoodleStar,
  DoodleUnderline,
  Icon,
  Marker,
  PaintedRibbon,
  ScribbleCircle,
  SectionTitle,
  Stamp,
  Stat,
  Sticky,
  Tape
} from './ui.jsx';
import { ArtistCard, ArtistModal, ArtistModalHost, ArtistRow, ParcoursCard, StatusDot, VenueCard } from './cards.jsx';

Object.assign(window, {
  Icon,
  Brand,
  BrandMark,
  Navbar,
  Footer,
  BrushBlob,
  BrushStroke,
  DoodleArrow,
  DoodleUnderline,
  DoodleCircle,
  DoodleScribble,
  DoodleStar,
  DoodleDots,
  Tape,
  Stamp,
  Sticky,
  Marker,
  ScribbleCircle,
  AsteriskHand,
  OrganicPhoto,
  FramedPhoto,
  MiniMap,
  BelgiumMap,
  StatusDot,
  ParcoursCard,
  ArtistCard,
  ArtistRow,
  ArtistModal,
  ArtistModalHost,
  VenueCard,
  Stat,
  SectionTitle,
  ChipGroup,
  PaintedRibbon,
  fetchCommunePolygon,
  addCommuneBoundaryLayer,
  baseTileLayer,
  fetchAddressLonLat
});
